import { useMutation, useQuery } from 'react-query';
import { useProgramSetupDao, ProgramSetupDaoPayload } from 'shared/dao/programSetupDao';
import {
  IProgramSetupCreatePayload,
  IProgramSetupRequestPayload,
  IProgramSetupResponsePayload,
  IProgramSetupUpdatePayload,
} from 'shared/interfaces/IProgramSetup';

const {
  createProgramSetup: createProgramSetupDao,
  updateProgramSetup: updateProgramSetupDao,
  deleteProgramSetup: deleteProgramSetupDao,
  getProgramSetup: getProgramSetupDao,
} = useProgramSetupDao();

export const useProgramSetupService = () => {
  const getProgramSetup = (payload?: IProgramSetupRequestPayload) => {
    // payload.media_source_name = 'video';
    return useQuery<IProgramSetupResponsePayload, Error>(
      ['program_setup', payload],
      () => getProgramSetupDao(payload),
      {
        enabled: !!payload,
      },
    );
  };

  const createMutation = useMutation((payload: ProgramSetupDaoPayload<IProgramSetupCreatePayload>) =>
    createProgramSetupDao(payload),
  );
  const updateMutation = useMutation((payload: ProgramSetupDaoPayload<IProgramSetupUpdatePayload>) =>
    updateProgramSetupDao(payload),
  );
  const deleteMutation = useMutation((id: string) => deleteProgramSetupDao(id));

  const createProgramSetup = () => {
    return {
      createMutation,
    };
  };

  const updateProgramSetup = () => {
    return {
      updateMutation,
    };
  };

  const deleteProgramSetup = () => {
    return {
      deleteMutation,
    };
  };

  return {
    getProgramSetup,
    createProgramSetup,
    updateProgramSetup,
    deleteProgramSetup,
  };
};
